import store from '../store/index'

export default class TrainingService {
    async getTrainings() {
        const data = await store.dispatch('jv/get', ['trainings', {params: {include: 'staff'}}]);
        return Object.values(data)
    }

    async createTraining(payload) {
        return await store.dispatch('jv/post', payload)
    }

    async updateTraining(payload) {
        return await store.dispatch('jv/patch', payload)
    }

    async deleteTraining(id) {
        return await store.dispatch('jv/delete', `trainings/${id}`)
    }

    logError(e) {
        const error = []
        if (e.response.data.errors) {
            // Work with each error from the JSONAPI 'errors' array
            for (const err of e.response.data.errors) {
                error.push(err.detail)
            }
        }
        return error
    }

    availableCategories() {
        return [
            { name: 'Accounting' },
            { name: 'Arbitration/Mediation' },
            { name: 'Arborist' },
            { name: 'BIM' },
            { name: 'Biology/Ecology' },
            { name: 'Building' },
            { name: 'Civil' },
            { name: 'Computer Science' },
            { name: 'Contract' },
            { name: 'Environmental' },
            { name: 'Geology/Earth Science' },
            { name: 'Geotechnical' },
            { name: 'GIS' },
            { name: 'HSE/Safety' },
            { name: 'Information Technology' },
            { name: 'Landscape' },
            { name: 'Law' },
            { name: 'Material' },
            { name: 'Mechanical' },
            { name: 'Quality Assurance' },
            { name: 'Site Supervision' },
            { name: 'Structural' },
            { name: 'Surveying' },
            { name: 'Transportation' },
            { name: 'Others' }
        ];
    }


}
